<ng-container [formGroup]="formGroupCampaignTypeData">
    <mdb-form-control class="form-fill" data-panel="settings" >
        <app-mdbp-input mdbInput formControlName="goal" data-panel="settings" [isCurrencyMask]="true" label='Optional Campaign Goal'>
            <input  #inputNameC currencyMask formControlName="goal" class="form-control form-control--paybee"/>
        </app-mdbp-input>
    </mdb-form-control>
    <div class="divider"></div>
    <app-mdb-switch label="Hide pledge option" formControlName="hidePledge"></app-mdb-switch>
    <div class="divider"></div>
    <app-mdb-switch label="Hide custom amount" formControlName="hideCustom"></app-mdb-switch>
    <div class="divider"></div>
    <app-mdb-switch label="Hide recurring donation" formControlName="hideRecurring"></app-mdb-switch>
    <div class="w-100" style="padding-left: 44px;" *ngIf="!formGroupCampaignTypeData.value.hideRecurring">
        <app-recurring-donation formControlName="frequencyOptions"></app-recurring-donation>
        <div
            class="row"
            *ngIf="formGroupCampaignTypeData.controls.frequencyOptions.dirty
                && formGroupCampaignTypeData.controls.frequencyOptions.hasError('required')"
        >
            <div class="col">
                <small class="red-text">Select at least one option</small>
            </div>
        </div>
    </div>
</ng-container>